// extracted by mini-css-extract-plugin
module.exports = {"container_sort_desktop_comp":"styles_container_sort_desktop_comp__2tMxs","inner_container":"styles_inner_container__88mHM"};